import { selectDealerProvinceCode } from '../../core/reducers/dealer';
import { useAppSelector } from '../../core/utils';
import { useProvinces } from '../sitecoreContext';
const useDealerProvincePricing = () => {
    var _a, _b;
    const sitecoreProvinces = useProvinces();
    const dealerProvinceCode = useAppSelector(selectDealerProvinceCode);
    const isSellingPriceProvince = (_b = (_a = sitecoreProvinces === null || sitecoreProvinces === void 0 ? void 0 : sitecoreProvinces.find(province => (province === null || province === void 0 ? void 0 : province.name) === dealerProvinceCode)) === null || _a === void 0 ? void 0 : _a.showSellingPrice) !== null && _b !== void 0 ? _b : true;
    return { dealerProvinceCode, isSellingPriceProvince };
};
export default useDealerProvincePricing;
